import React from 'react';
import GriffInput from '../commons/GriffInput.jsx'
import SidebarFrame from "./SidebarFrame";

export default class GriffeSettings extends SidebarFrame {

    state = {}

    renderTitle() {
        return I18N("Griffe");
    }

    renderBody() {
        const griff = APP.findProduct(APP.arrangement.griffArtikelnummer);

        return (
            <>
            {griff &&
            <div class="griff">
                <div
                    key="currentValue"
                    className="griff-item dummyproduct stopselect"
                    style={{
                        backgroundImage:'url('+SETTINGS.wkfgContentBaseUrl + griff.Bild+')'
                    }}
                    title={griff.Anzeigename}
                >
                </div>
                <div className="griff-name">
                    {griff.Anzeigename}
                </div>
            </div>
            }
            
            <div className="appear">
                {APP.getGriffGruppen()
                    .filter(gruppe => APP.getGriffeForGruppe(gruppe.Name).length >= 1)
                    .map( (griffGruppe,index) => (
                    <GriffInput key={griffGruppe.Name}
                                label={griffGruppe.Name}
                                griffe={APP.getGriffeForGruppe(griffGruppe.Name)}
                                value={APP.arrangement.griffArtikelnummer}
                                appear={true}
                                setValue={APP.model.tryWrap(this,value=>APP.arrangement.setGriffArtikelnummer(value))}
                                />
                ))}
            </div>
            </>
        )
    }
}